import { Component, OnInit, Input, ContentChild, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { DataAccessService } from '../../services/data-access.service';
import { TranslationService } from '../../services/translation-service.service';

@Component({
    selector: 'translate',
    templateUrl: './translate.component.html',
    styleUrls: ['./translate.component.scss'],
})
export class TranslateComponent implements OnInit {

    @Input() ts: TranslationService;
    @Input() key: string;
    @Input() variables: string[] = [];
    @Input() indent: boolean;

    private default: string = '&nbsp;';
    private initialized: boolean = false;
    
    constructor(private changeDetection: ChangeDetectorRef, private dataAccess: DataAccessService) { }

    ngOnInit() {
        if (!this.ts) {
            this.ts = new TranslationService();
            this.ts.init(['App'], this.dataAccess, this);
        }
    }

    @ViewChild('contentWrapper') content: ElementRef;

    ngAfterViewInit() {
        if (!this.initialized) {
            this.default = this.content.nativeElement.innerText.trim();
            this.initialized = true;
            this.changeDetection.detectChanges();
        }
    }

    text() {
        if (this.initialized)
            return this.ts.translate(this.key, this.default, this.variables);
        return this.default;
    }
}
